






















































































































import Vue from 'vue'
import _ from 'lodash'
import { CurrentUser } from '@/model/CurrentUser'
import Password from '@/components/employee-form/Password.vue'
import { FETCH_EMPLOYEE_PHOTO, LOAD_CURRENT_USER_ABSENCES, LOAD_CURRENT_USER_BALANCE } from '@/store/action-types'
import { CurrentUserAbsence } from '@/model/CurrentUserAbsence'
import { Balance } from '@/model/Balance'

interface ComponentData {
  activeTab: number
  selectedYear: number
  absencesData: Array<CurrentUserAbsence>
  balanceData: Balance
  employeePhoto: string | undefined
}

export default Vue.extend({
  name: 'ProfilePage',

  components: {
    Password
  },

  data (): ComponentData {
    return {
      activeTab: 0,
      selectedYear: 0,
      absencesData: [],
      balanceData: Balance.createEmpty(),
      employeePhoto: undefined
    }
  },

  methods: {
    async loadAbsences (): Promise<void> {
      this.absencesData = await this.$store.dispatch(LOAD_CURRENT_USER_ABSENCES, {
        ID: this.$store.state.currentUser.id,
        year: this.selectedYear
      })
    },

    async loadBalanceData (): Promise<void> {
      this.balanceData = await this.$store.dispatch(LOAD_CURRENT_USER_BALANCE, this.$store.state.currentUser.id)
    },

    async fetchPhoto (): Promise<void> {
      try {
        this.employeePhoto = await this.$store.dispatch(FETCH_EMPLOYEE_PHOTO, this.$store.state.currentUser.id)
      } catch (e) {
        this.employeePhoto = undefined
      }
    }
  },

  computed: {
    currentUser (): CurrentUser {
      return this.$store.state.currentUser
    },

    years (): Array<number> {
      return _.range(new Date().getFullYear(), 1999, -1)
    }
  },

  watch: {
    selectedYear (newVal) {
      if (newVal) {
        this.selectedYear = newVal
        this.loadAbsences()
      }
    }
  },

  mounted () {
    this.selectedYear = this.years[0]
    this.loadAbsences()
    this.loadBalanceData()
    this.fetchPhoto()
  }
})
